
/** Вспомогательный класс для управление библиотекой RubyToJS */
class RubyControl {

	/** Список скриптовых файлов */
	static RubyScripts = [
		"/new/rubytojs/opal.min.js",
		"/new/rubytojs/opal-parser.min.js",
		"/new/rubytojs/native.min.js",
		"/new/rubytojs/DateTime.min.js",
		"/new/rubytojs/Guid.min.js",
		"/new/rubytojs/ArrayExt.min.js",
		"/new/rubytojs/opalRunner.js"
	];

	/** Подключение скриптов к странице */
	static initRuby = () => {
		if ( !window.Opal ) {
			console.log( "Подгружаем OpalRuby" );
			for (let index = 0; index < this.RubyScripts.length; index++) {
				const scriptPath = this.RubyScripts[index];
				this.loadScript( scriptPath, index );
			}
		}
	};

	/** Удаление скриптов с страницы */
	static unInitRuby = () => {
		console.log( "Удаляем OpalRuby" );
		for (let index = 0; index < this.RubyScripts.length; index++) {
			this.unLoadScript( index );
		}
	};

	/** Добавляет скрипт к странице */
	static loadScript = ( scriptPath: string, index: number ) => {
		const script = document.createElement("script");
		script.setAttribute("type", "text/javascript");
		const url = window.host + scriptPath;
		// В качестве источника для скрипта формируем адрес метода апи
		script.setAttribute("src", url);
		script.setAttribute( "id", "Ruby_" + index );
		script.async = false;
		window.document.head.appendChild( script );
	};

	/** Удаляет скрипт с страницы */
	static unLoadScript = ( index: number ) => {
		const id = "Ruby_" + index;
		const script = document.getElementById(id);
		if (script != null) {
			window.document.head.removeChild(script);
		}
	};
};

export default RubyControl;
